import { ComponentProps } from 'react';

import { cx } from '@libs/classnames';

import styles from './FancyPanel.module.css';

export type FancyPanelControlProps = {} & ComponentProps<'button'>;

export function FancyPanelControl({ className, ...rest }: FancyPanelControlProps) {
  return <button className={cx(styles.control, className)} {...rest} />;
}
